import { NgxRolesService } from 'ngx-permissions';
import { AuthService } from './../../../services/auth.service';
import { ExcelService } from './../../../services/excel.service';
import { Observable } from 'rxjs/Observable';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Bus } from './../../../models/bus';
import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Select2OptionData } from 'ng2-select2';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { PNotifyService } from '../../../services/pnotify.service';
import { depenses } from './../../../models/depenses';

@Component({
  selector: 'app-depenses-edition',
  templateUrl: './depenses-edition.component.html',
  styleUrls: ['./depenses-edition.component.css']
})
export class DepensesEditionComponent implements OnInit, OnDestroy {
  
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();
  

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    type: '',
    title: '',
    dateInterval: [
      new Date(moment(this.currentYear+'-08-20').format('YYYY-MM-DD')),
      new Date(moment().format('YYYY-MM-DD'))
    ],
  };
  staticFilter: any;
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  // ----- End Option Scrollbar -----------

  selectedAll = false;
  selectedMulti = false;

  dtOptions: any = {};
  clients: any[];
  schools: any[];
  buses: any[];
  expenses: any[];
  pnotify = undefined;
  isResponsible = false;
  typeData: any[];
  selectedType: any;
  expense: depenses;
  modalOpen: any;
  dtCurrentpage: any;
  dtCurrentLen: any;
  dtIntiFlag: any;
  
  modalExpense = {
    clientId: '',
    schoolId: '',
    busId: '',
    type: '',
    title: '',
    date: ''
  };

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private router: Router,
    private route: ActivatedRoute,
    private zone: NgZone,
    private excelService: ExcelService,
    pnotifyService: PNotifyService
  ) { 
    this.initClientSelect();
    this.initExpenseType();
    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }

  }

  ngOnInit(): void {
    
    const columns = [
        { data: 'checkbox' },
        { data: 'title' },
        { data: 'type' },
        { data: 'bus' },
        { data: 'price' },
        { data: 'date' },
        { data: 'actions' }
    ];

    if (this.roleService.getRole('ROLE_ADMIN')) {
      columns.splice(2, 0, { data: 'schoolName' });
      //columns.splice(5, 0, { data: 'simTracker' }); 
    }

    // Check if the current date is before August 20th of the current year
    // If so, decrement the currentYear by 1
    // Info: annee scolaire commence en 20/08/xxxx
    if (this.currentDate < new Date(this.currentYear, 7, 20)) {
      this.currentYear--;
    }
    this.filter.dateInterval[0] = new Date(moment(this.currentYear+'-08-20').format('YYYY-MM-DD'));

    console.log("staticFilter");
    console.log(this.staticFilter);
    this.dtOptions = {
      searching: false,
      pageLength: 5,
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/depenses',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.expenses = resp.data;
          const dta = [];
          this.expenses.forEach((expense, index) => {
            const btnDelete = `<button class="btn btnAction btnDelete  " data-expense-id="${expense.id}">
                                <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                              </button>`;
            dta.push({
              id: expense.id,
              checkbox: `<label class="el-switch" style="font-size:80%">
                          <input  type="checkbox"
                                  name="checkboxs[]"
                                  value="${expense.id}"
                                  ${this.selectedAll ? 'checked' : ''}
                          >
                          <span class="el-switch-style"></span>
                        </label>`,
              title: expense.title,
              type: expense.type,
              bus: expense.Bus.name,
              price: expense.price + " DH",
              date: moment(expense.expenseDate).format('DD/MM/YYYY'),
              actions: `
                <a class="btn btnAction btnView "data-expense-id="${expense.id}">
                  <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
                </a>
                <a class="btn btnAction btnEdit "data-expense-id="${expense.id}">
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>Modifier
                </a>
                <button class="btn btnAction btnDelete  " data-expense-id="${expense.id}">
                  <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                </button>
              `
            });
            if (this.roleService.getRole('ROLE_ADMIN')) {
              dta[index].schoolName = expense.bus.School.name;
              //dta[index].simTracker = bus.simTracker;
            }
          });
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'expense_' + aData.id);
      },
      columns: columns,
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };

    $('table').on('click', '.btnDelete', (event) => {
      this.onDeleteExpense($(event.currentTarget).data('expenseId'));
    });
    $('table').on('click', '.btnView', (event) => {
      this.showViewModal($(event.currentTarget).data('expenseId'));
    });
    $('table').on('click', '.btnEdit', (event) => {
      this.showEditModal($(event.currentTarget).data('expenseId'));
    });
    $('table').on('change', '[name="checkboxs[]"]', (event) => this.onCheckChange());
    $('table').on('draw.dt', (event) => this.onCheckChange());
  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }


  goPaginationEnd() : void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      const pgsInfo = dtInstance.page.info();
      const totalPg = pgsInfo.pages;
      let pgNo = totalPg - 1;

      dtInstance.page(pgNo);
      dtInstance.draw(false);
   });
  }

  updateCurrentPagination() : void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      const pgsInfo = dtInstance.page.info();
      const dtCurrentpage = pgsInfo.page;
      //this.dtCurrentLen = pgsInfo.length;
      //console.log ('this.dtCurrentpage' + dtCurrentpage);
      dtInstance.page(dtCurrentpage);
      dtInstance.draw(false);
   });
  }
  
 onDtDrawChange() {
    this.onCheckChange();
  }

  initExpenseType(){
    this.typeData = [
      { id: '', text: 'Choisir un type'},                
      { id: 'Gazoil', text: 'Gazoil'},
      { id: 'Assurance', text: 'Assurance'},
      { id: 'Vidange', text: 'Vidange'},
      { id: 'VisteT', text: 'Visite technique'},
      { id: 'Reparation', text: 'Reparation'},
      { id: 'Autre', text: 'Autre'},
    ];
  }

  typeFiltreChanged(e: any){
    this.filter.type = e.value;
  }
  
  typeExpenseChanged(e: any){
    this.expense.type = e.value;
  }

  typeExpenseChanged_Edition(e: any){
    this.expense.type = e;
  }


  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
        this.clientsData = array1.concat(array2);
        this.initSchoolSelect();
      });
    }
    this.staticFilter = this.filter;
  }

  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      this.filter.schoolId = schools.length ? schools[0].id : '';
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { 
            id: school.id, 
            text: school.name,
            selected: (index === 0) ? true : false
          };
        }
      });
      this.schoolsData = array1.concat(array2);
      this.busesData = [{ id: '', text: 'Choisir une option' }];
    });
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  schoolChanged_Edition(e: any) {
    this.filter.schoolId = e;
    this.initBusSelect();
  }

  initBusSelect() {
    this.filter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir une option' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
    });
  }

  busChanged(e: any) {
    this.filter.busId = e.value;
  }

  busExpenseChanged(e: any){
    this.expense.busId = e.value;
  }

  busExpenseChanged_Edition(e: any){
    this.expense.busId = e;
  }

  onSelectedAllChange() {
    $('[name="checkboxs[]"]').prop('checked', this.selectedAll);
    this.onCheckChange();
  }

  onCheckChange() {
    const length = $('[name="checkboxs[]"]:checked').length;
    if (length > 1) {
      this.selectedMulti = true;
    } else {
      this.selectedMulti = false;
    }
  }

  onNavigate(url) {
    this.zone.run(() => this.router.navigateByUrl(url));
  }

  onDeleteExpense(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkDelete() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.delete($(elt).val());
                });
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http
      .delete('/api/depenses/' + id)
      .subscribe(
        result => {
          document.getElementById('expense_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }


  showAddModal() {
    
    this.expense = new depenses();

    // Create a new Date instance for today's date
    const today = new Date();

    // Get the individual components of the date
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    // Format the date as a string in the desired format (YYYY-MM-DD)
    const formattedDate = `${year}-${month}-${day}`;

    // Assign the formatted date to the expense creationDate property
    this.expense.creationDate = formattedDate;
    this.expense.modificationDate = formattedDate;

    // Init mandatory parameters
    this.expense.title = '';
    this.expense.price = null;
    this.selectedType = '';
    $("#selectModalType").val(null).trigger("change");
    this.expense.type = this.filter.type;
    this.expense.clientId = isNaN(parseInt(this.filter.clientId))  ? '' : parseInt(this.filter.clientId)+'';
    this.expense.schoolId = isNaN(parseInt(this.filter.schoolId)) ? '' : parseInt(this.filter.schoolId)+'' ;
    this.expense.busId = isNaN(parseInt(this.filter.busId))  ? '' : parseInt(this.filter.busId)+'';
    
    console.log('expense');
    console.log(this.expense);
    // add code to init chan;ps bus, type, ...
    /*  this.typeData = this.typeData.map((data, index) => {
      console.log (index);
      return {
        id: data.id,
        text: data.text,
        selected: data.id == 'VisteT' ? true : false
      };
    });  */

    $('#ModalExpense').modal('show');
    this.modalOpen = 'addExpense';
    setTimeout(() => {
    }, 500);
  }

  showEditModal(expenseId){
    this.http.get(
      '/api/depenses/' + expenseId
    ).subscribe((expense: depenses) => {
      this.expense = expense;
      $('#ModalExpense').modal('show');
      this.modalOpen = 'editExpense';
      setTimeout(() => {
      }, 500);
    });
  }

  showViewModal(expenseId){
    this.http.get(
      '/api/depenses/' + expenseId
    ).subscribe((expense: depenses) => {
      this.expense = expense;
      $('#ModalExpense').modal('show');
      this.modalOpen = 'viewExpense';
      setTimeout(() => {
      }, 500);
    });

  }

  onAddExpense(){

    const selectedDate = new Date(this.expense.expenseDate);
    this.expense.expenseDate = this.formatSelectedDate(selectedDate);
    //this.expense.filePath = "-";

    this.http.post(
      '/api/depenses/0',
      { expense: this.expense }
    ).subscribe(
      (expense: depenses) => {
        $('#ModalExpense').modal('hide');
        this.goPaginationEnd();
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

  onEditExpense(){
    const selectedDate = new Date(this.expense.expenseDate);
    this.expense.expenseDate = this.formatSelectedDate(selectedDate);
    //this.expense.filePath = "-";

    this.http.put(
      '/api/depenses/' + this.expense.id,
      { expense: this.expense }
    ).subscribe(
      (expense: depenses) => {
        $('#ModalExpense').modal('hide');
        this.updateCurrentPagination();
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

 /*  onViewExpense(id){ // no need for the moment

  } */


  // Function to format the selected date
  formatSelectedDate(selectedDate: Date): string {
    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
    const day = String(selectedDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  onExport() {
    this.http.post(
      '/api/depenses',
      { filter: this.staticFilter }
    ).subscribe((resp: any) => {
      
      const depenseData = [
        [
          'ID',
          'Titre',
          'Type',
          'Bus',
          'Date',
          'Prix',
          'Kilometrage (KM)',
          'Volume (L)',
          'Note',
          'Date de creation',
          'Date de modification',
        ]
      ];
      
      for (let i = 0; i < resp.data.length; i++) {
        depenseData.push([
          'ID_' + resp.data[i].id,
          resp.data[i].title,
          resp.data[i].type,
          resp.data[i].Bus.name,
          moment(resp.data[i].expenseDate).format('DD/MM/YYYY') ,
          resp.data[i].price,
          resp.data[i].kilometrage,
          resp.data[i].volume,
          resp.data[i].note,
          resp.data[i].creationDate,
          resp.data[i].modificationDate,
        ]);
      }

      this.excelService.exportAsExcelFileWithMultiplePage([
        {
          name: 'Depense',
          data: depenseData
        }], 'Rapport depense');
    });
  }

  onFilter(): void {
    this.staticFilter = this.filter;
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/depenses/depenses-edition/depenses-edition.component.ts